// extracted by mini-css-extract-plugin
export default {"icon-container":"TopHeader_icon-container__-0UM9","icon-subcontainer":"TopHeader_icon-subcontainer__v-gpU"};